import { render, staticRenderFns } from "./BookingDeadlineInput.vue?vue&type=template&id=fce48238&scoped=true&"
import script from "./BookingDeadlineInput.vue?vue&type=script&lang=js&"
export * from "./BookingDeadlineInput.vue?vue&type=script&lang=js&"
import style0 from "./BookingDeadlineInput.vue?vue&type=style&index=0&id=fce48238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce48238",
  null
  
)

export default component.exports